module.exports = __webpack_public_path__ + "img/icon-favorite-article-cover.43fb949b.png";